module.exports = __webpack_public_path__ + "img/panch_cuento_8.2e977ae7.png";